<style lang="stylus" scoped>
    .fileview-menu
        height 28px
        .fileview-menu-tool
            @media screen and (max-width: 900px)
                display none !important
</style>

<template>
    <div class="ed-fileview" @click="clear" v-click-outside="clear" @contextmenu.stop.prevent>
        <div class="fileview-title">{{ $t("title") }}</div>
        <div class="fileview-menu">
            <MenuList v-model="menuId" :defaultId="0" :menuList="dateList" @toMenu="toMenu" />
            <div class="fileview-menu-tool">
                <Search v-model="searchStr" @toSearch="toSearch" @searchBack="searchBack"></Search>
                <div class="tool-btn" @click="setLayout">
                    <img class="tool-icon" :src="require(`@/home/assets/pcview/${layoutMode}-mode.svg`)" />
                </div>
            </div>
        </div>

        <div style="overflow: hidden">
            <FilesSelector
                v-if="mulSelectMode"
                :type="'openRecord'"
                :totalNum="activeList.length"
                :fileNum="selectFilesIndex.length"
                @selectAllFiles="selectAllFiles"
                @cancelSelect="cancelSelect"
                @delFiles="deleteRecord"
            />
        </div>

        <Searchback v-if="searchMode" :str="lastSearch" :num="activeList.length" @searchBack="searchBack" />

        <div v-if="layoutMode == 'list' && !searchMode && !emptyStatus" class="fileview-list-header fileview-list-header-recent">
            <div class="file-name">
                <span>{{ $t("name") }}</span>
            </div>
            <div class="file-time">
                <span>{{ $t("time") }}</span>
            </div>
            <div class="file-size">
                <span>{{ $t("size") }}</span>
            </div>
            <div class="file-select"></div>
        </div>

        <div class="fileview-scroll" @scroll="clear" ref="filesScroll">
            <DragSelector
                :boxClassName="layoutMode == 'grid' ? 'files-item' : 'fileview-files-item-list'"
                :scrollDom="$refs.filesScroll"
                :containerDom="$refs.filesBoxList"
                @dragMouseDown="dragMouseDown"
                @dragMouseMove="dragMouseMove"
                @dragMouseUp="dragMouseUp"
                @setActiveList="dragSelectIndex"
            />
            <div class="emptyCloud limit-position" v-cloak v-if="emptyStatus">
                <img src="@/home/assets/img/null-icon/default-null.svg" alt="" />
                <span>{{ $t("notTem") }}</span>
            </div>

            <template v-if="layoutMode == 'grid'">
                <div class="files-box" ref="filesBoxList">
                    <gridFile
                        v-for="item in activeList"
                        :key="item.index"
                        :type="'openRecord'"
                        :mode="'files'"
                        :index="item.index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        :searchKey="searchStr"
                        @setStarFile="setStarFile"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                        @closeContextmenu="contextmenuBoxShow = false"
                    />
                </div>
            </template>

            <template v-if="layoutMode == 'list'">
                <div class="files-box-list files-box-list-recent" ref="filesBoxList">
                    <listFile
                        v-for="item in activeList"
                        :key="item.index"
                        :type="'openRecord'"
                        :mode="'files'"
                        :index="item.index"
                        :mulSelectMode="mulSelectMode"
                        :file="item"
                        :searchKey="searchStr"
                        @setStarFile="setStarFile"
                        @enterMulSelectMode="mulSelectMode = true"
                        @cancelMulSelectMode="mulSelectMode = false"
                        @closeContextmenu="contextmenuBoxShow = false"
                    />
                </div>
            </template>
        </div>

        <RightMenu
            v-if="contextmenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="rightmenuList"
            @handleClicks="handleClick($event)"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
    import MenuList from "./parts/menu.vue";
    import Search from "./parts/search.vue";
    import fileItem from "../fileItem";
    import listFile from "./listFile.vue";
    import gridFile from "./gridFile.vue";
    import FilesSelector from "./FilesSelector.vue";
    import DragSelector from "../DragSelector.vue";
    import RightMenu from "../RightMenu.vue";
    import Searchback from "./parts/searchback.vue";
    @Component({
        components: {
            MenuList,
            Search,
            listFile,
            gridFile,
            FilesSelector,
            DragSelector,
            RightMenu,
            Searchback,
        },
    })
    export default class Recent extends Mixins(fileItem) {
        dateList = [];
        menuId = 0;
        searchStr = "";
        lastSearch = "";

        loadingStatus = false;
        deleteRecordBlock = false;
        filesList = [];
        searchList = [];
        nowList = [];
        sevenList = [];
        nowMList = [];
        otherList = [];
        get emptyStatus() {
            return this.userInfo && this.filesList && this.filesList.length == 0 && !this.loadingStatus;
        }
        get rightmenuList() {
            let list = [
                { key: 0, label: this.$t("openFile"), ban: this.fileSelected.length > 1 },
                {
                    key: 1,
                    label: this.$t("locateFile"),
                    hide: !this.isPC,
                    ban: this.fileSelected.length > 1,
                },
                { key: 2, label: this.$t("deleteRecord") },
            ];
            return list.filter((i) => (i.hasOwnProperty("hide") ? i.hide : true));
        }
        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        get contextmenuBoxShow() {
            return this.$store.state.fileContextShow;
        }

        set contextmenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: v,
            });
        }
        clear() {
            this.contextmenuBoxShow = false;
        }
        handleClick(index) {
            let clickEvents = new Map([
                [
                    0,
                    () => {
                        this.fileSelected.length == 1 && this.openFiles(this.activeList[this.fileSelected[0]]);
                    },
                ],
                [
                    1,
                    () => {
                        this.fileSelected.length == 1 && this.locateFile();
                    },
                ],
                [
                    2,
                    () => {
                        this.deleteRecord();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(index);
            onClicks && onClicks();
            this.clear();
        }
        locateFile() {
            if (this.fileSelected.length > 1) return;
            let file = null;
            for (let item of this.activeList) {
                if (this.fileSelected[0] == item.index) {
                    file = item;
                    break;
                }
            }
            this.$bus.$emit("jumpToCloud", file);
        }

        initList() {
            this.dateList = [
                {
                    id: 0,
                    label: this.$t("all"),
                },
                {
                    id: 1,
                    label: this.$t("date-now"),
                },
                {
                    id: 2,
                    label: this.$t("date-7day"),
                },
                {
                    id: 3,
                    label: this.$t("date-nowMonth"),
                },
                {
                    id: 4,
                    label: this.$t("date-other"),
                },
            ];
        }
        @Watch("lang")
        watchLang(nv, ov) {
            if (nv != ov) {
                this.$nextTick(() => {
                    this.initList();
                });
            }
        }
        toMenu() {
            if (this.searchMode) {
                this.searchBack();
            }
            if (this.mulSelectMode) {
                this.clearFile();
            }
        }
        getRelativeTime(timeStamp) {
            let nowZero = new Date(new Date().toLocaleDateString()).getTime(); // 当天零点
            let sevenZero = nowZero - 6 * 24 * 60 * 60 * 1000; // 7天零点
            let nowMonthZero = new Date(new Date().toLocaleDateString()).setDate(1); // 当月零点

            const currentTime = new Date().getTime();
            let diff = currentTime - timeStamp;
            if (diff < 0 || timeStamp > nowZero) {
                return "now";
            } else if (timeStamp > sevenZero) {
                return "7day";
            } else if (timeStamp > nowMonthZero) {
                return "nowMonth";
            } else {
                return "other";
            }
        }
        getHistoryViewList() {
            if (!this.params || !this.params.islogin) {
                return;
            }
            this.loadingStatus = true;
            // this.filesList = [];
            this.$store.commit("setState", { data: true, type: "showLoading" });
            let obj = {
                platform: this.$store.state.publicStore.runPlatform,
            };
            Object.assign(obj, this.params);
            this.$edApi
                .getOpenRecord(obj)
                .then((list) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    list.sort((a, b) => {
                        return new Date(b.opened_at).getTime() - new Date(a.opened_at).getTime();
                    });
                    let arr = [];
                    let nowArr = [],
                        sevenArr = [],
                        nowMArr = [],
                        otherArr = [];
                    let addToArr = (obj) => {
                        let time = new Date(obj.opened_at);
                        let type = this.getRelativeTime(time);
                        switch (type) {
                            case "now":
                                nowArr.push(obj);
                                break;
                            case "7day":
                                sevenArr.push(obj);
                                break;
                            case "nowMonth":
                                nowMArr.push(obj);
                                break;
                            case "other":
                                otherArr.push(obj);
                                break;
                        }
                    };
                    let index = 0;
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].obj) {
                            let obj = {
                                index: index,
                                id: list[i].id,
                                objId: list[i].obj_id,
                                key: list[i].obj.obj,
                                size: list[i].obj.size,
                                opened_at: list[i].opened_at,
                                info: list[i].obj || null,
                                name: "",
                            };
                            if (this.isPrivate) {
                                obj.name = list[i].obj.name;
                                Object.assign(obj, {
                                    prefix: list[i].prefix,
                                });
                            } else {
                                let nameList = obj.key.split("/");
                                let name = nameList[nameList.length - 1];
                                name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                obj.name = name;
                            }
                            arr.push(obj);
                            addToArr(obj);
                            index++;
                        }
                    }
                    this.filesList = arr;
                    this.nowList = nowArr;
                    this.sevenList = sevenArr;
                    this.nowMList = nowMArr;
                    this.otherList = otherArr;
                    this.loadingStatus = false;
                })
                .catch((err) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    this.loadingStatus = false;
                });
        }
        deleteRecord() {
            if (this.deleteRecordBlock) return;
            this.deleteRecordBlock = true;
            let selectArr = [];
            let list = this.activeList;
            for (let i = 0; i < this.fileSelected.length; i++) {
                if (!list[this.fileSelected[i]]) continue;
                selectArr.push(list[this.fileSelected[i]].id);
            }
            let params = Object.assign({ objId: selectArr }, this.$store.getters.apiParam);
            this.$edApi
                .deleteOpenRecord(params)
                .then((e) => {
                    this.getHistoryViewList();
                    this.clearFile();
                    this.deleteRecordBlock = false;
                })
                .catch((e) => {
                    this.deleteRecordBlock = false;
                });
        }
        clearFile(keepMulSelectMode = 0) {
            this.selectFilesIndex = [];
            !keepMulSelectMode && (this.mulSelectMode = false);
        }
        mulSelectMode = false;
        get selectFilesIndex() {
            return this.$store.state.selectFilesIndex;
        }
        set selectFilesIndex(v) {
            this.$store.commit("setState", {
                type: "selectFilesIndex",
                data: v,
            });
        }
        get activeList() {
            if (this.searchMode) {
                return this.searchList;
            } else {
                return this.activeMenuList;
            }
        }
        get activeMenuList() {
            switch (this.menuId) {
                case 0:
                    return this.filesList;
                case 1:
                    return this.nowList;
                case 2:
                    return this.sevenList;
                case 3:
                    return this.nowMList;
                case 4:
                    return this.otherList;
            }
        }
        get layoutMode() {
            return this.$store.state.layoutMode;
        }
        set layoutMode(v) {
            this.$store.commit("setState", {
                type: "layoutMode",
                data: v,
            });
        }
        setLayout() {
            this.$store.commit("changeLayout");
            this.clearFile();
        }
        selectAllFiles(type) {
            if (!type) {
                this.clearFile(1);
            } else {
                let arr = [];
                for (let i = 0; i < this.activeList.length; i++) {
                    arr.push(i);
                }
                this.$store.commit("setState", {
                    type: "selectFilesIndex",
                    data: arr,
                });
            }
        }
        cancelSelect() {
            this.clearFile();
        }
        dragMouseDown() {
            this.clearFile(1);
        }
        dragMouseMove() {}
        dragMouseUp(isMove, isClickFile) {
            if (!isMove) {
                if (this.mulSelectMode && isClickFile) {
                } else {
                    this.clearFile();
                }
            } else this.selectFilesIndex.length > 0 && (this.mulSelectMode = true);
        }
        dragSelectIndex(data) {
            let trueIndex = [];
            for (let item of data) {
                trueIndex.push(this.activeList[item].index);
            }
            this.selectFilesIndex = trueIndex;
        }
        get searchMode() {
            return this.$store.state.history.searchMode;
        }
        set searchMode(v) {
            this.$store.commit("setHistoryStatus", {
                searchMode: v,
            });
        }
        toSearch() {
            console.log(this.searchStr);
            this.searchStr = this.searchStr.trim();
            if (this.searchStr) {
                this.lastSearch = this.searchStr;
                this.searchMode = true;
                this.searchList = [];
                this.$store.commit("setState", { data: true, type: "showLoading" });
                this.searchList = this.activeMenuList.filter((item) => {
                    if (item.name.toLowerCase().includes(this.searchStr.toLowerCase())) {
                        if (this.isPrivate) {
                            item.filePath = item.prefix ? this.$t("personal") + ">" + item.prefix : this.$t("personal");
                        } else {
                            let filePath = item.key.match(/[^\/]+\/[^\/]+\/(.+)/) && item.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                            filePath = filePath.split("/");
                            let name = filePath.pop();
                            filePath = filePath.length ? this.$t("personal") + ">" + filePath.join(">") : this.$t("personal");
                            item.filePath = filePath;
                        }
                        return true;
                    }
                    return false;
                });
                if (this.searchList.length == 0) {
                    (<any>this).$edMessage.error(this.$t("notFind"));
                }
                this.$store.commit("setState", { data: false, type: "showLoading" });
            } else {
                this.searchMode = false;
            }
        }
        searchBack() {
            this.searchMode = false;
            this.searchStr = "";
        }

        get selFiles() {
            let list = this.activeList;
            return list.filter((_, i) => {
                return this.selectFilesIndex.includes(i);
            });
        }
        setStarFile(file = null) {
            let done = () => {
                this.$bus.$emit("changeFileInfo", {
                    id: tempId,
                    key: "start_tag",
                    path,
                    value: type,
                });
                this.$bus.$emit("refreshStar");
                // this.getHistoryViewList();
            };
            let tempId = -1;
            let type = 0;
            let path = "",
                pathArr = [];
            if (file) {
                type = file.info.start_tag ^ 1;
                tempId = file.info.id;
                pathArr = file.info.obj.split("/");
                pathArr.shift();
                pathArr.shift();
                pathArr.pop();
                this.$store
                    .dispatch("setStarFile", {
                        type: type,
                        id: file.info.id,
                        file_key: file.info.file_key,
                    })
                    .then((res) => {
                        file.info.start_tag = type;
                        done();
                    });
            } else {
                type = this.selFiles[0].info.start_tag ^ 1;
                tempId = this.selFiles[0].info.id;
                pathArr = this.selFiles[0].key.split("/");
                pathArr.shift();
                pathArr.shift();
                pathArr.pop();
                if (pathArr.length > 0) {
                    path = pathArr.join("/") + "/";
                }
                this.$store
                    .dispatch("setStarFile", {
                        type: type,
                        id: this.selFiles[0].info.id,
                        file_key: file.info.file_key,
                    })
                    .then((res) => {
                        this.selFiles[0].info.start_tag = type;
                        done();
                    });
            }
        }

        //生命周期
        mounted() {
            this.initList();
        }

        visibilitychangeEvent() {
            let state = document.visibilityState;
            if (state == "visible") {
                this.getHistoryViewList();
            }
        }
        created() {
            this.$store.commit("setState", { data: 20, type: "selectId" });
            this.$bus.$on("refreshHistoryView", () => {
                this.getHistoryViewList();
            });
            if (this.params?.islogin) {
                this.getHistoryViewList();
            } else {
                this.$bus.$on("loginSucc-history", () => {
                    this.getHistoryViewList();
                });
            }
            document.addEventListener("visibilitychange", this.visibilitychangeEvent);
        }
        beforeDestroy() {
            this.clearFile();
            this.searchMode = false;
            this.contextmenuBoxShow = false;
            this.$bus.$off("refreshHistoryView");
            this.$bus.$off("loginSucc-history");
            // window.removeEventListener("message", this.receiveMessage);
            document.onvisibilitychange = null;
            document.removeEventListener("visibilitychange", this.visibilitychangeEvent);
        }
    }
</script>
<i18n>
    {
      "zh": {
        "title": "最近打开",
        "name": "文件名",
        "time": "打开时间",
        "size": "文件大小",
        "openFile": "打开",
        "locateFile": "定位到",
        "deleteRecord": "删除记录",
        "search": "搜索文件",
        "return": "返回",
        "notTem": "您最近没有浏览过自己的文件~",
        "notFind": "没有查到相应的浏览记录",
        "date-month": "月",
        "all": "全部",
        "date-now": "今天",
        "date-preday": "昨天",
        "date-7day": "7天内",
        "date-nowMonth": "本月",
        "date-preMonth": "上月",
        "switchView": "切换视图",
        "personal": "个人云",
        "date-other": "更早"
      },
      "en": {
        "title": "Recent",
        "name": "File name",
        "time": "Open time",
        "size": "File size",
        "openFile": "Open",
        "locateFile": "Targeting",
        "deleteRecord": "Delete",
        "search": "Search file",
        "return": "Return",
        "notTem": "You have not viewed your files recently.",
        "notFind": "Not Find",
        "date-month": "Month",
        "all": "All",
        "date-now": "Today",
        "date-preday": "Yesterday",
        "date-7day": "Within 7 days",
        "date-nowMonth": "This Month",
        "date-preMonth": "Last Month",
        "switchView": "Switch View",
        "personal": "Personal",
        "date-other": "Earlier"
      },
      "fr": {
        "title": "Récent",
        "name": "nom de fichier",
        "time": "Temps ouvert",
        "size": "Taille du fichier",
        "openFile": "ouvrir",
        "locateFile": "Ciblage",
        "deleteRecord": "supprimer",
        "search": "Rechercher un fichier",
        "return": "retour",
        "notTem": "Vous n'avez pas consulté vos fichiers récemment.",
        "notFind": "Aucun historique de navigation correspondant trouvé",
        "date-month": "Mois",
        "all": "Tout",
        "date-now": "Aujourd'hui",
        "date-preday": "Hier",
        "date-7day": "Dans les 7 jours",
        "date-nowMonth": "Ce mois-ci",
        "date-preMonth": "Le mois dernier",
        "switchView": "Changer de vue",
        "personal": "Cloud personnel",
        "date-other": "Plus tôt"
      },
      "de": {
        "title": "Zuletzt",
        "name": "Dateiname",
        "time": "Öffnungszeit",
        "size": "Dateigröße",
        "openFile": "Anschalten",
        "locateFile": "Lokalisieren",
        "deleteRecord": "Aufzeichnung löschen",
        "search": "Datei durchsuchen",
        "return": "Rückkehr",
        "notTem": "Sie haben Ihre Dateien in letzter Zeit nicht angezeigt.",
        "notFind": "Keinen entsprechenden Browsenverlauf gefunden",
        "date-month": "Monat",
        "all": "Alle",
        "date-now": "Heute",
        "date-preday": "Gestern",
        "date-7day": "Innerhalb von 7 Werktage",
        "date-nowMonth": "Diesen Monat",
        "date-preMonth": "Letzten Monat",
        "switchView": "Ansicht wechseln",
        "personal": "Persönlicher Cloud",
        "date-other": "Früher"
      },
      "jp": {
        "title": "閲覧履歴",
        "name": "ファイル名",
        "time": "時間",
        "size": "サイズ",
        "openFile": "開く",
        "locateFile": "保存場所",
        "deleteRecord": "削除",
        "search": "ファイルを検索",
        "return": "戻る",
        "notTem": "最近開いたファイルはありません",
        "notFind": "該当する閲覧履歴は見つかりませんでした",
        "date-month": "月",
        "all": "すべて",
        "date-now": "今日",
        "date-preday": "昨日",
        "date-7day": "7日以内",
        "date-nowMonth": "今月",
        "date-preMonth": "先月",
        "switchView": "ビューを切り替える",
        "personal": "個人クラウド",
        "date-other": "以前"
      },
      "es": {
        "title": "Recientes",
        "name": "nombre del archivo",
        "time": "Tiempo abierto",
        "size": "Tamaño del archivo",
        "openFile": "encender",
        "locateFile": "Orientación",
        "deleteRecord": "Eliminar el registro",
        "search": "Archivo de búsqueda",
        "return": "regreso",
        "notTem": "No ha visto sus archivos recientemente",
        "notFind": "No encontrar",
        "date-month": "Mes",
        "all": "Todo",
        "date-now": "Hoy",
        "date-preday": "Ayer",
        "date-7day": "Dentro de 7 dias",
        "date-nowMonth": "Este mes",
        "date-preMonth": "El mes pasado",
        "switchView": "Cambiar vista",
        "personal": "Nube Personal",
        "date-other": "Más temprano"
      },
      "pt": {
        "title": "Recente",
        "name": "nome do arquivo",
        "time": "Tempo aberto",
        "size": "Tamanho do arquivo",
        "openFile": "Ligar",
        "locateFile": "Alvejando",
        "deleteRecord": "Apagar registro",
        "search": "Pesquisar arquivo",
        "return": "Retorna",
        "notTem": "Você não olhou para seus arquivos recentemente",
        "notFind": "Não Encontrado",
        "date-month": "mês",
        "all": "Todos",
        "date-now": "hoje",
        "date-preday": "ontem",
        "date-7day": "Dentro de 7 dias",
        "date-nowMonth": "este mês",
        "date-preMonth": "mês anterior",
        "switchView": "Trocar Visualização",
        "personal": "Pessoal",
        "date-other": "Mais cedo"
      },
      "it": {
        "title": "Recente",
        "name": "nome del file",
        "time": "Tempo aperto",
        "size": "Dimensione del file",
        "openFile": "accendere",
        "locateFile": "Targeting",
        "deleteRecord": "Elimina record",
        "search": "Cerca file",
        "return": "ritorno",
        "notTem": "Guarda quanto spazio vuoto che c'è! Che ne diresti di ravvivare un po' la situazione?",
        "notFind": "Nessuna cronologia di navigazione corrispondente trovata",
        "date-month": "Mese",
        "all": "tutto",
        "date-now": "Oggi",
        "date-preday": "Ieri",
        "date-7day": "Entro 7 giorni",
        "date-nowMonth": "Questo mese",
        "date-preMonth": "Il mese scorso",
        "switchView": "Cambia Vista",
        "personal": "Personali",
        "date-other": "Prima"
      },
      "tw": {
        "title": "最近",
        "name": "檔案名",
        "time": "打開時間",
        "size": "檔案大小",
        "openFile": "打開",
        "locateFile": "定位到",
        "deleteRecord": "刪除記錄",
        "search": "搜尋檔案",
        "return": "返回",
        "notTem": "您最近沒有瀏覽過自己的檔案~",
        "notFind": "沒有查到相應的瀏覽記錄",
        "date-month": "月",
        "all": "全部",
        "date-now": "今天",
        "date-preday": "昨天",
        "date-7day": "7天內",
        "date-nowMonth": "本月",
        "date-preMonth": "上月",
        "switchView": "切換視圖",
        "personal": "個人雲端硬碟",
        "date-other": "早些時候"
      },
      "kr": {
        "title": "신규 순",
        "name": "이름",
        "time": "파일 열기 시간",
        "size": "파일 크기",
        "openFile": "파일 열기",
        "locateFile": "파일 위치",
        "deleteRecord": "기록 삭제",
        "search": "파일 찾기",
        "return": "돌아가기",
        "notTem": "아직 사용자님이 생성한 파일을 한 번도 조회하지 않았습니다!",
        "notFind": "해당 파일을 찾을 수 없습니다!",
        "date-month": "달",
        "all": "모두",
        "date-now": "요즘",
        "date-preday": "어제",
        "date-7day": "7 일 이내",
        "date-nowMonth": "이번 달",
        "date-preMonth": "지난 달",
        "switchView": "보기 전환",
        "personal": "개인 클라우드",
        "date-other": "더 일찍"
      },
      "id": {
        "title": "Terbaru",
        "name": "Nama file",
        "time": "Buka waktu",
        "size": "Ukuran file",
        "openFile": "Buka",
        "locateFile": "Penargetan",
        "deleteRecord": "Hapus",
        "search": "Cari file",
        "return": "Kembali",
        "notTem": "Anda belum melihat file Anda baru-baru ini.",
        "notFind": "Tidak Menemukan",
        "date-month": "Bulan",
        "all": "Semua",
        "date-now": "Hari Ini",
        "date-preday": "Kemarin",
        "date-7day": "7 hari ini",
        "date-nowMonth": "Bulan Ini",
        "date-preMonth": "Bulan Lalu",
        "switchView": "Ganti Tampilan",
        "personal": "Personal",
        "date-other": "Lebih awal"
      }
    }
    </i18n>
